import styled from "styled-components";
import media from "../../styles/media";

/** Базовая карточка списка (новости, отчёты, объявления). */
export const Card = styled.article`
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.md};
  box-shadow: ${({ theme }) => theme.shadows.card};
  transition:
    transform ${({ theme }) => theme.transitions.base},
    box-shadow ${({ theme }) => theme.transitions.base},
    border-color ${({ theme }) => theme.transitions.base};

  &:hover {
    transform: translateY(-4px);
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
  }

  ${media.md} {
    padding: 16px;
  }
`;

/** Вертикальный список карточек с одинаковым шагом. */
export const CardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  ${media.md} {
    gap: 14px;
  }
`;

export default Card;
